import { render, staticRenderFns } from "./VerifyPhoto.vue?vue&type=template&id=571bc7f0&scoped=true&"
import script from "./VerifyPhoto.vue?vue&type=script&lang=js&"
export * from "./VerifyPhoto.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPhoto.vue?vue&type=style&index=0&id=571bc7f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bc7f0",
  null
  
)

export default component.exports